/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Visibilita\' del TipoPratica sulle superfici REST (cittadino vs backoffice)
 */
export enum VisualizzazioneTipoPratica {

    PUBBLICA = 'PUBBLICA',

    INTERNA = 'INTERNA'
}

